"use strict";

import { UserScriptConstants } from './UserScriptConstants';
import { AppDispatcher } from 'Dispatcher';
/**
 * @param fileName
 * @param funcName
 * @param nextStore
 * @param viewStore
 * @param formUUID
 * @param props
 */

export function formEditCustomAction(fileName, funcName, nextStore, viewStore, formUUID, props) {
  AppDispatcher.asyncDispatch({
    actionType: UserScriptConstants.FORM_EDIT_CUSTOM_ACTION,
    fileName: fileName,
    funcName: funcName,
    nextStore: nextStore,
    viewStore: viewStore,
    formUUID: formUUID,
    props: props
  });
}
export function tableCustomAction(options) {
  AppDispatcher.asyncDispatch({
    actionType: UserScriptConstants.TABLE_CUSTOM_ACTION,
    options: options
  });
}